/* eslint-disable */
import { Form, Select, Radio, Row, Col, Input, DatePicker } from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { ESTADOS, PROCESOS_ESPECIFICOS } from 'constants/nombresCatalogos';
import { DATE_FORMAT_FORM } from 'utils/date';
import { LOCAL, FEDERAL, AMBOS } from 'constants/ambitos';
import '../../../../Formulario.scss';
import * as fieldMsgs from 'constants/formFieldsMessages';
import dayjs from 'dayjs';
import { useState, useEffect } from 'react';
import moment from 'moment';

import { useDispatch } from 'react-redux';

import {
  getEntidadesPublico
} from 'actions/publicDownloads.actions';

const DatosGenerales = ({ form, idProcesoGeneral }) => 
{
  const dispatch = useDispatch();

  const { TextArea } = Input;
  const entidades = useSelector(selectCatalogByName(ESTADOS));
  const procesos = useSelector(selectCatalogByName(PROCESOS_ESPECIFICOS));
  const placement = 'topRight';
  const dateFormat = 'YYYYMMDD';
  const [fechaFinOper, setFechaFinOper] = useState(null);

  const [estadosEsp, setEstadosEsp] = useState([]);

  useEffect(() => 
  {
    if (idProcesoGeneral) 
    {
      setFechaFinOper(moment().format('YYYYMMDD HH:mm:ss'));
      getEntidadesPorProceso();
    }
  }, [idProcesoGeneral]);

  const getEntidadesPorProceso = async () =>
  {
    try 
    {
      // Obtenemos los Estados por el proceso específico
      const { success: scsEstados, response: respEstados } = await dispatch(
        getEntidadesPublico({ idProceso: idProcesoGeneral }, false)
      );

      if (scsEstados && respEstados?.data) 
      {
        var estados = [];
        const estadosFiltrados = respEstados.data.filter((e) => e.id > 0);
        //Revisamos si el estado guardado en BD existe en nuestro arrelglo, si no existe lo insertamos
        if(form.getFieldsValue().idEstado)
        {
          const estadosNoexistentes = estadosFiltrados.find(x => x.id === form.getFieldsValue().idEstado);
          if(estadosNoexistentes === undefined)
          {
            const estadosFaltantes = entidades.find(x => x.idEstado === form.getFieldsValue().idEstado);
            estadosFiltrados.push({id: estadosFaltantes.idEstado, valor: estadosFaltantes.nombreEstado})
          }
        }
        
        // Estados Finales, estados propios del proceso y en dado caso estados faltantes por un mal registro
        entidades.forEach(element => {
          if(estadosFiltrados.find(x => x.id === element.idEstado))
          {
            estados.push(element);
          }
        });

        setEstadosEsp(estados);
      }
    } catch (error) 
    {
      console.log('Error: ', error);  
    }
  }

  const handleClearBeneficiados = () => {
    // Al ser dependientes los beneficiarios del proceso hay que remover a los beneficiarios
    // al cambiar el proceso para evitar discrepancias
    form.setFieldsValue({
      beneficiados: [],
      tipo_beneficio: null
    });
  };

  const handleChangeEntidad = () => 
  {
    form.setFieldsValue({ idMunicipio: null, idDistritoLoc: null, idDistritoFed: null,
      beneficiados: [],
      tipo_beneficio: null });
  };

  return (
    <div>
      <Form form={form} layout="vertical" name="Datos Generales">
        <Row gutter={[24, 0]} className="row-formulario">
          <Col xs={6}>
            <Form.Item
              name="idEstado"
              label="Entidad:"
              rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
              <Select
                placeholder="Selecciona una entidad"
                options={estadosEsp}
                onChange={handleChangeEntidad}
                fieldNames={{
                  value: 'idEstado',
                  label: 'nombreEstado'
                }}
                filterOption={(inputValue, option) =>
                  option.nombreEstado?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                }
                showSearch
              />
            </Form.Item>
          </Col>
          <Col xs={6}>
            <Form.Item
              name="idProcesoEspecifico"
              label="Proceso:"
              rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
              <Select
                placeholder="Selecciona un proceso"
                options={procesos}
                onChange={handleClearBeneficiados}
                fieldNames={{
                  value: 'idProcesoEspecifico',
                  label: 'nombreProcesoEspecifico'
                }}
                filterOption={(inputValue, option) =>
                  option.nombreProcesoEspecifico
                    ?.toUpperCase()
                    .indexOf(inputValue.toUpperCase()) !== -1
                }
                showSearch
              />
            </Form.Item>
          </Col>
          <Col xs={6}>
            <Form.Item
              name="idAmbito"
              label="Ámbito:"
              rules={[{ required: true, message: fieldMsgs.ERR_RADIO_FIELD_REQUIRED }]}
              onChange={handleClearBeneficiados}>
              <Radio.Group className="radiog radio-style">
                <Radio value={FEDERAL}>Federal</Radio>
                <Radio value={LOCAL}>Local</Radio>
                <Radio value={AMBOS}>Ambos</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[24, 0]} className="row-formulario">
          <Form.Item
            noStyle
            shouldUpdate={(prevProps, newProps) =>
              prevProps.idEstado !== newProps.idEstado || prevProps.idAmbito !== newProps.idAmbito
            }>
            {() => {
              const { idEstado, idAmbito } = form.getFieldsValue(['idEstado', 'idAmbito']);
              const distritosLocales =
                estadosEsp.find((e) => e.idEstado === idEstado)?.distritosLocales || [];
              const distritosFederales =
                estadosEsp.find((e) => e.idEstado === idEstado)?.distritosFederales || [];
              return (
                <>
                  {(idAmbito === LOCAL || idAmbito === AMBOS) && (
                    <Col xs={6}>
                      <Form.Item
                        name="idDistritoLoc"
                        label="Distrito Local"
                        rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                        <Select
                          placeholder="Selecciona un distrito"
                          fieldNames={{
                            value: 'idDistrito',
                            label: 'cabeceraDistrital'
                          }}
                          options={distritosLocales}
                          filterOption={(inputValue, option) =>
                            option.cabeceraDistrital
                              ?.toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          showSearch
                        />
                      </Form.Item>
                    </Col>
                  )}
                  {(idAmbito === FEDERAL || idAmbito === AMBOS) && (
                    <Col xs={6}>
                      <Form.Item
                        name="idDistritoFed"
                        label="Distrito Federal"
                        rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                        <Select
                          placeholder="Selecciona un distrito"
                          fieldNames={{
                            value: 'idDistrito',
                            label: 'cabeceraDistrital'
                          }}
                          options={distritosFederales}
                          filterOption={(inputValue, option) =>
                            option.cabeceraDistrital
                              ?.toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          showSearch
                        />
                      </Form.Item>
                    </Col>
                  )}
                </>
              );
            }}
          </Form.Item>
        </Row>
        <Row gutter={[24, 0]} className="row-formulario">
          <Col span={24}>
            <Form.Item
              className="input-acuerdo-cof"
              name="acuerdoCOF"
              label="Acuerdo COF:"
              rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
              <TextArea
                showCount
                maxLength={2000}
                allowClear
                placeholder="Escribe..."
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[24, 0]} className="row-formulario">
          <Col span={6}>
            <Form.Item
              name="fechaAcuerdoAprobado"
              label="Fecha de Acuerdo de la COF:"
              rules={[{ required: true, message: fieldMsgs.ERR_DATE_FIELD_REQUIRED }]}>
              <DatePicker
                className="space-calendario"
                placement={placement}
                placeholder="dd/mm/aaaa"
                format={DATE_FORMAT_FORM}
                maxDate={dayjs(fechaFinOper, dateFormat)}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

DatosGenerales.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    getFieldsValue: PropTypes.func
  }).isRequired,
  idProcesoGeneral: PropTypes.number.isRequired
};

export default DatosGenerales;
